import React from 'react'
import Action from '../../model/Action'
import { Query } from '../../model/Query'

export function changeSearch(
    dispatch: React.Dispatch<Action>, payload: string
) {
    dispatch({ type: 'changeSearch', payload })
}

export function changePage(
    dispatch: React.Dispatch<Action>, payload: number
) {
    dispatch({ type: 'changePage', payload })
}

export function changeLimit(
    dispatch: React.Dispatch<Action>, payload: number
) {
    dispatch({ type: 'changeLimit', payload })
}

export function changeArea(
    dispatch: React.Dispatch<Action>, payload: string
) {
    dispatch({ type: 'changeArea', payload })
}

export function changeCity(
    dispatch: React.Dispatch<Action>, payload: string
) {
    dispatch({ type: 'changeCity', payload })
}

export function changeType(
    dispatch: React.Dispatch<Action>, payload: string
) {
    dispatch({ type: 'changeType', payload })
}

export function changeAdmin(
    dispatch: React.Dispatch<Action>, payload: boolean
) {
    dispatch({ type: 'changeAdmin', payload })
}

export function changeQuery(
    dispatch: React.Dispatch<Action>, payload: Query
) {
    dispatch({ type: 'changeQuery', payload })
}
